import router from '@/router';
import AuthService from '@/services/auth';

import iView from 'iview';

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  next();
});

router.beforeEach((to, from, next) => {
  const auth = to.matched.some(r => r.meta.auth);
  if (auth) {
    if (!AuthService.isLoggedIn()) {
      next({ name: 'login', query: { redirect: to.fullPath } });
      return;
    }
  }
  next();
});

router.beforeEach((to, from, next) => {
  if (to.name === 'login'
    && to.query.redirect
    && !AuthService.isLoggedIn()) {
    next({ to: to.query.redirect });
    return;
  }
  next();
});

router.afterEach(() => {
  iView.LoadingBar.finish();
});
